/*
 *   File : list.js
 *   Author : https://evoqins.com
 *   Description : prime data page
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

// custom components
import { PrimaryButton, SecondaryButton, TextButton } from '../../Components/Buttons';
import { FileSelector } from '../../Components/FormElements';
import { ConfirmModal } from '../../Components/Modal';
import { APIService, AWSService } from '../../Service';
import { CustomRadio } from '../../Components/Others';

const RADIO_DATA = [
    {
        id: 1,
        label: "Prime funds",
    },
    {
        id: 2,
        label: "Prime rating"
    }
];

const PrimeData = () => {

    const FILE_TYPES = ["XLSX", "CSV"];

    const [selectedFileError, setSelectedFileError] = useState("");
    const [file, setFile] = useState(null);

    const [uploadModal, setUploadModal] = useState(false);
    const [fileLoader, setFileLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [fileName, setFileName] = useState({});

    const [selected, setSelected] = useState(1);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (uploadModal === true) {
            const upload_modal = new Modal(document.getElementById('confirm-modal'));
            upload_modal.show();
        }
    }, [uploadModal]);


    useEffect(() => {
        setSelectedFileError("");
    }, [file])

    // handle upload file
    const _handleChange = (file) => {
        if (file.size > 1024 * 1024 * 10) {
            setSelectedFileError("File size exceeds the maximum limit of 10 MB");
            return;
        }
        _getPresignedUrl(file);
    };

    // handle upload file
    const _handleUpload = () => {

        let is_valid = true;

        if (file === null) {
            setSelectedFileError("please upload a file");
            is_valid = false;
        }
        if (is_valid === true) {
            _updateFile();
        }
    };

    const _handleClose = (type) => {
        if (type === 1) {
            setFile(null);
        } else {
            console.log("log");
        }
    };


    // handle select user 
    const _handleSelect = (id) => {
        if (fileLoader === false) {
            setSelected(id);
        }

        setSelectedFileError("");
        setFile(null);
    };

    const _handleDownload = async () => {
        if (selected === 1) {
            const url = "https://rayi-dev.s3.amazonaws.com/public/admin/master/PrimeFund_16_10_2025.csv";
            const response = await fetch(url);
            const blob = await response.blob();
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'SamplePrimeData.csv';
            a.click();

        } else {
            const url = "https://rayi-dev.s3.amazonaws.com/public/admin/master/PrimeRating_16_10_2025.csv";
            const response = await fetch(url);
            const blob = await response.blob();
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'SamplePrimeRating.csv';
            a.click();
        }
    }

    // Get - presigned url
    async function _getPresignedUrl(file) {

        let is_post = true;
        let url = 'file/upload';
        let data = {
            "type": "ADMIN",
            "file": file.name,
            "is_public": true
        };

        setFileLoader(true);
        setFileName(data)

        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        setFile(response.data.view_info);
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) { }
        setFileLoader(false);
    };

    // API - Update file
    const _updateFile = () => {
        let is_post = true;
        let url = 'prime-data/update-file';
        let data = {
            "file": file,
            "type": selected
        }
        setButtonLoader(true);
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setUploadModal(true);
            }
            else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setButtonLoader(false);
        });
    };

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <h3 className='mb-0 e-text-chinese-black e-primary-font e-font-24 e-font-weight-600 line-height-24px'>
                        Prime Data
                    </h3>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    <div className='e-bg-white border-radius-16 padding-32px-all min-vh-75 pb-5'>

                        <div className='row pb-3'>
                            <div className='col-lg-8 col-md-10 col-12'>
                                <div className='d-flex justify-content-between align-items-start'>
                                    <h4 className='mb-4  e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                        Import data
                                    </h4>
                                </div>

                                <CustomRadio data={RADIO_DATA}
                                    selected={selected}
                                    className="d-flex flex-row gap-3"
                                    handleSelect={_handleSelect} />
                            </div>
                        </div>

                        {/* user selection */}
                        <div className='row'>
                            <div className='col-lg-8 col-md-10 col-12'>
                                <div className='position-relative'>
                                    <FileSelector
                                        title='Upload file'
                                        downloadTitle='Download sample file'
                                        required={true}
                                        primeDataSize='Maximum file size: 10 MB'
                                        primeData='File supported: .CSV, .XLSX'
                                        type={1}
                                        error={selectedFileError}
                                        value={file}
                                        fileDetails={fileName}
                                        fileType={FILE_TYPES}
                                        maxSize={1024 * 1024 * 10}
                                        loader={fileLoader}
                                        handleChange={_handleChange}
                                        handleClose={() => _handleClose(1)} />

                                    <div className='position-absolute top-0 end-0'>
                                        <TextButton name="Download sample file"
                                            onClick={_handleDownload} />
                                    </div>

                                </div>

                                <div className='d-flex gap-24px justify-content-end'>
                                    <SecondaryButton name='Cancel'
                                        paddingBlock='padding-12px-tb padding-50px-lr'
                                        onClick={() => _handleClose(1)} />
                                    <PrimaryButton name='Upload'
                                        paddingBlock='padding-12px-tb padding-50px-lr'
                                        className={buttonLoader ? "w-144px" : ""}
                                        onClick={_handleUpload}
                                        loader={buttonLoader} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* confirm modal */}
            {uploadModal === true &&
                <ConfirmModal title='Success!'
                    status={true}
                    description='The file has been successfully uploaded and all record has been processed and updated.'
                    handleClose={() => {
                        setTimeout(() => {
                            setUploadModal(false);
                        }, 200);
                    }}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setUploadModal(false);
                            setFile(null);
                        }, 200);
                    }} />

            }
        </Fragment>
    )
}

export default PrimeData;
